module.exports = __webpack_public_path__ + "img/logo-putih.56fa2784.png";